<template>
  <div class="content">
    <QuizHeader/>
    <div :style="{background: bgTheme}" style="height: 200px;"></div>
    <div class="" style="margin-top: -155px; margin-left: 10px; margin-right: 10px">
      <div class="quiz-question-section common-block margin-vertical-10">
        <div class="circle-timer-section" style="z-index: 5" >
          <div class="timer">
            <!--<span>Hrs</span>
            <span>Mns</span>
            <span>Sec</span>-->
            <div class="question_timer is-countdown">
              <span class="countdown-row countdown-amount" style="margin-top: 1.25rem;">
                {{Math.floor(qtime/1000/60)}}m:{{(qtime/1000)%60 }}s
              </span>
            </div>
          </div>
        </div>
        <div class="title border-bottom text-center" style="margin-top: 40px">
          <span>Question {{quizNo + 1}}/{{quizData.length}}</span>
        </div>

        <div class="question-block">
          <p>{{quizData[quizNo] ? quizData[quizNo].question : ''}}</p>

          <div
              v-for="(item, index) in currentQuizQuest"
              :class="[!nextQuiz ? 'no-cursor' : 'on-cursor', item.selected ? 'selected-option' : '',item.correct ? 'correct-answer' : '', 'options-block']"
              v-on:click="handleQuizAnswer(item)"
          >
            <span>{{ item.key }}</span>
            <p>{{ item.value }}</p>
          </div>

          <div class="confirmation-btn text-center">
            <a
                :class="[!nextQuiz ? 'disabled' : '', 'btn btn-pink btn-uppercase btn-font-big']"
                role="button"
                v-on:click="handleNextQuestion()"
            >
              Next
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade exit-quiz-modal show" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog" style="padding-right: 17px; display: block;" v-if="showExitModal">
      <div class="modal-dialog modal-dialog-centered" style="position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%); width: 100%;">
        <div class="modal-content">
          <div class="modal-body">
            <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                v-on:click="closeModal()"
            >
              <img src="@/assets/close.svg" alt="close" class="img-fluid">
            </button>
            <div class="modal-title">
              <span>Are you sure, you want to Exit?</span>
            </div>
            <p>You will lose your Score and won't be able to rejoin this Quiz.</p>

            <div class="modal-buttons">
              <a
                  class="btn btn-simple-pink"
                  v-on:click="exitQuiz()"
              >
                Exit
              </a>
              <a
                  class="btn btn-pink"
                  role="button"
                  data-dismiss="modal"
                  v-on:click="closeModal()"
              >
                Continue Quiz
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Tasks from '../components/Tasks'
import { globals } from "@/mixins/globals"
import QuizHeader from '@/components/quiz-header'
import axios from "axios"
export default {
  mixins: [globals],
  name: 'quiz-questions',
  props: {
    date: {
      type: String
    }
  },
  components: {
    // Quiz
    // AddTask,
    // Tasks,
    QuizHeader
  },
  data: () => ({
    displayDays: 0,
    displayHours: 0,
    displayMinutes: 0,
    displaySeconds: 0,
    distance: 3600000,
    question_time: 0,
    qtime:0,
    time_bonus: 0,
    currentQuizQuest: [],
    nextQuiz: false,
    quizNo: 0,
    game_id: null,
    quizData: [],
    answers: [],
    currentQuestion: null,
    correctAnswersCount: 0,
    final_screen_data: []
  }),
  computed: {
    _seconds: () => 1000,
    _minutes() {
      return this._seconds * 60
    },
    _hours() {
      return this._minutes * 60
    },
    _days() {
      return this._hours * 24
    },
  },
  methods: {
    closeModal() {
      this.$store.state.showExitModal = false;
    },
    exitQuiz() {
      this.submitAnswers();
    },
    showRemaining() {
      const timer = setInterval(() => {
        if (this.qtime < 0) {
          if (this.quizNo === (this.quizData.length - 1)) {
            clearInterval(timer);
          }
          this.handleNextQuestion();
          // this.submitAnswers();

          return
        }
        /*const seconds = parseInt(Math.floor(this.distance % this._minutes) / this._seconds);
        const minutes = parseInt(Math.floor(this.distance % this._hours) / this._minutes);
        const days = parseInt(Math.floor(this.distance / this._days));
        const hours = parseInt(Math.floor(this.distance % this._days) / this._hours);


        this.displayMinutes = minutes < 10 ? "0" + minutes : minutes + "m";
        this.displaySeconds = seconds < 10 ? "0" + seconds : seconds + "s";
        this.displayHours = hours < 10 ? "0" + hours : hours + "h";
        this.displayDays = days < 10 ? "0" + days : days;

        this.distance = this.distance - 1000*/
        this.qtime = this.qtime - 1000;
      }, 1000)
    },
    handleQuizAnswer(item) {
      if(this.nextQuiz){
        return
      }
      item.selected = true;
      this.nextQuiz = true;
      this.currentQuizQuest = this.currentQuizQuest.filter(i => i.correct ? i.selected = true : false && i.id == item.id ? item : i);
      this.answers.push({key: item.question_id, value: item.key})
      if (item.correct) {
        this.correctAnswersCount += 1;
      }
    },
    handleNextQuestion() {
      this.time_bonus += this.qtime;
      if (this.quizNo !== (this.quizData.length - 1)) {
        this.qtime = this.question_time * 1000;
      }
      if (this.quizNo == (this.quizData.length - 1)) {
        this.submitAnswers();
      } else {
        this.distance = this.qtime;
        this.quizNo = this.quizNo + 1;
        this.nextQuiz = false;
        var mm = this.quizNo
        var bb = this.quizData[mm];
        this.currentQuizQuest = this.quizData[this.quizNo].options;
      }
    },
    submitAnswers() {
      var self = this;
      var url = self.$store.getters.flyyDomain + '/record_score/'+self.game_id;
      var headers = self.$store.getters.headers;
      var time = self.time_bonus / 1000
      if (time < 0) {
        time = 0
      }
      self.$store.state.quiz_time_bonus = time;
      var body = {
        quiz_result: this.answers,
        time: time
      }
      axios.post(url, body, {
        headers: headers,
      }).then((resp) => {
        if(resp.status == 200) {
          this.$store.state.showExitModal = false;
          var data = resp.data;
          // console.log(data)
          // self.game_data = data.game;
          var answers_score = (self.correctAnswersCount * 1000);
          var total_score =  answers_score + time
          var currentUrl = window.location.pathname;
          if(currentUrl == "/play-quiz"){
            self.$router.replace({name: 'congrats', params: {total_questions: self.quizData.length, correct_answers: self.correctAnswersCount, total_score: total_score, answers_score: answers_score, time_score: time, final_screen_data: self.final_screen_data}})
          }
        } else {
          console.log("Error Submitting Answers");
        }
      })
    },
    fetchQuizQuestions() {
      var self = this;
      var url = self.$store.getters.flyyDomain + '/play_quiz/'+self.game_id;
      var headers = self.$store.getters.headers;
      axios.get(url, {
        headers: headers,
      }).then((resp) => {
        if(resp.status == 200) {
          var data = resp.data;
          if (!data.success) {
            this.$router.go(-1)
            return;
          }
          // console.log(data)
          // self.game_data = data.game;

          var b = new Buffer(data.key, "base64")
          var c = JSON.parse(b.toString());

          var apt = {}
          c.forEach(function (item) {
            apt[item["key"]] = item["value"]
          });

          var finalData = [];
          data.questions.forEach(function (item) {
            var formattedOptions = []
            item.options.forEach(function (opt) {
              formattedOptions.push({
                key: opt["key"],
                value: opt["value"],
                selected: false,
                correct: apt[item.id] == opt["key"],
                question_id: item.id
              });
            });
            finalData.push({
              id: item.id,
              question: item.question,
              options: formattedOptions
            });
          });

          // console.log(finalData);
          self.quizData = finalData;
          self.question_time = data.quiz_timer;
          self.qtime = self.question_time * 1000;
          //self.distance = self.question_time;
          self.$store.state.final_screen_data = data.final_screen_data;
          self.currentQuizQuest = self.quizData[0].options;
          self.currentQuestion = self.currentQuizQuest[0];
          self.final_screen_data = data.final_screen_data
          self.showRemaining();
        } else {
          console.log("Error fetching the Quiz Questions");
        }
      })
    }
  },
  created() {
    // this.$emit('handleHideFooter');
    this.game_id = this.$route.params.id;
    this.$store.state.quizDetailsTitle = "Quiz Questions";
    this.fetchQuizQuestions();
  },
  mounted() {
    this.$store.state.showQuizHistoryMenu = false;
  }
}
</script>

<style scoped>
  @import '../assets/quiz-styles/quiz-styles.css';
  /*@import '../assets/quiz-styles/bootstrap.css';*/
  @import '../assets/fonts/quiz-fonts/fonts.css';
</style>



// WEBPACK FOOTER //
// src/screens/quiz-questions.vue